/**
 * ATNA Logging API Documentation
 * Rest API used to query log entries
 *
 * OpenAPI spec version: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from "./XHR"
import { PaginatedListSyslog } from '../model/PaginatedListSyslog';


export class IccSyslogApi {
  host: string
  headers: Array<XHR.Header>
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  constructor(host: string, headers: any, fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>) {
    this.host = host
    this.headers = Object.keys(headers).map(k => new XHR.Header(k, headers[k]))
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this.headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }


     /**
      * 
      * @summary List 
      * @param roleIdCode EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byActiveParticipantRoleIdCode(roleIdCode: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byActiveParticipantRoleIdCode` + "?ts=" + new Date().getTime() 
          + (roleIdCode ? "&roleIdCode=" + encodeURIComponent(String(roleIdCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param roleIdCode EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byActiveParticipantRoleIdCodeAndDate(roleIdCode: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byActiveParticipantRoleIdCodeAndDate` + "?ts=" + new Date().getTime() 
          + (roleIdCode ? "&roleIdCode=" + encodeURIComponent(String(roleIdCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param activeparticipantUserId EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byActiveParticipantUserId(activeparticipantUserId: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byActiveParticipantUserId` + "?ts=" + new Date().getTime() 
          + (activeparticipantUserId ? "&activeparticipantUserId=" + encodeURIComponent(String(activeparticipantUserId)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param activeparticipantUserId EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byActiveParticipantUserIdAndDate(activeparticipantUserId: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byActiveParticipantUserIdAndDate` + "?ts=" + new Date().getTime() 
          + (activeparticipantUserId ? "&activeparticipantUserId=" + encodeURIComponent(String(activeparticipantUserId)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param eventIdCode EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byEventIdCode(eventIdCode: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byEventIdCode` + "?ts=" + new Date().getTime() 
          + (eventIdCode ? "&eventIdCode=" + encodeURIComponent(String(eventIdCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param eventIdCode EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byEventIdCodeAndDate(eventIdCode: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byEventIdCodeAndDate` + "?ts=" + new Date().getTime() 
          + (eventIdCode ? "&eventIdCode=" + encodeURIComponent(String(eventIdCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param enventOutcomeIndicator EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byEventOutcomeIndicator(enventOutcomeIndicator: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byEventOutcomeIndicator` + "?ts=" + new Date().getTime() 
          + (enventOutcomeIndicator ? "&enventOutcomeIndicator=" + encodeURIComponent(String(enventOutcomeIndicator)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param enventOutcomeIndicator EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byEventOutcomeIndicatorAndDate(enventOutcomeIndicator: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byEventOutcomeIndicatorAndDate` + "?ts=" + new Date().getTime() 
          + (enventOutcomeIndicator ? "&enventOutcomeIndicator=" + encodeURIComponent(String(enventOutcomeIndicator)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param enventTypeCode EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byEventTypeCode(enventTypeCode: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byEventTypeCode` + "?ts=" + new Date().getTime() 
          + (enventTypeCode ? "&enventTypeCode=" + encodeURIComponent(String(enventTypeCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param enventTypeCode EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byEventTypeCodeAndDate(enventTypeCode: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byEventTypeCodeAndDate` + "?ts=" + new Date().getTime() 
          + (enventTypeCode ? "&enventTypeCode=" + encodeURIComponent(String(enventTypeCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectId EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byParticipantObjectId(participantObjectId: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byParticipantObjectId` + "?ts=" + new Date().getTime() 
          + (participantObjectId ? "&participantObjectId=" + encodeURIComponent(String(participantObjectId)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectId EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byParticipantObjectIdAndDate(participantObjectId: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byParticipantObjectIdAndDate` + "?ts=" + new Date().getTime() 
          + (participantObjectId ? "&participantObjectId=" + encodeURIComponent(String(participantObjectId)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectIdTypeCode EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byParticipantObjectIdTypeCode(participantObjectIdTypeCode: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byParticipantObjectIdTypeCode` + "?ts=" + new Date().getTime() 
          + (participantObjectIdTypeCode ? "&participantObjectIdTypeCode=" + encodeURIComponent(String(participantObjectIdTypeCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectIdTypeCode EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byParticipantObjectIdTypeCodeAndDate(participantObjectIdTypeCode: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byParticipantObjectIdTypeCodeAndDate` + "?ts=" + new Date().getTime() 
          + (participantObjectIdTypeCode ? "&participantObjectIdTypeCode=" + encodeURIComponent(String(participantObjectIdTypeCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param type Type
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byType(type: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byType` + "?ts=" + new Date().getTime() 
          + (type ? "&type=" + encodeURIComponent(String(type)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param type Type
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byTypeAndDate(type: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byTypeAndDate` + "?ts=" + new Date().getTime() 
          + (type ? "&type=" + encodeURIComponent(String(type)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectTypeCode EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byparticipantObjectTypeCode(participantObjectTypeCode: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byparticipantObjectTypeCode` + "?ts=" + new Date().getTime() 
          + (participantObjectTypeCode ? "&participantObjectTypeCode=" + encodeURIComponent(String(participantObjectTypeCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectTypeCode EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byparticipantObjectTypeCodeAndDate(participantObjectTypeCode: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byparticipantObjectTypeCodeAndDate` + "?ts=" + new Date().getTime() 
          + (participantObjectTypeCode ? "&participantObjectTypeCode=" + encodeURIComponent(String(participantObjectTypeCode)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectTypeCodeRole EventId code
      * @param limit Number results
      * @param from From date
      * @param to To Date
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byparticipantObjectTypeCodeAndDateRole(participantObjectTypeCodeRole: string, limit?: number, from?: number, to?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byparticipantObjectTypeCodeAndDateRole` + "?ts=" + new Date().getTime() 
          + (participantObjectTypeCodeRole ? "&participantObjectTypeCodeRole=" + encodeURIComponent(String(participantObjectTypeCodeRole)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (from ? "&from=" + encodeURIComponent(String(from)) : "")
          + (to ? "&to=" + encodeURIComponent(String(to)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @summary List 
      * @param participantObjectTypeCodeRole EventId code
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 byparticipantObjectTypeCodeRole(participantObjectTypeCodeRole: string, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/byparticipantObjectTypeCodeRole` + "?ts=" + new Date().getTime() 
          + (participantObjectTypeCodeRole ? "&participantObjectTypeCodeRole=" + encodeURIComponent(String(participantObjectTypeCodeRole)) : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}

     /**
      * 
      * @param date 
      * @param address 
      * @param agentIdentifier 
      * @param patientIdentifier 
      * @param entityIdentifier 
      * @param entityType 
      * @param entityRole 
      * @param sourceIdentifier 
      * @param type 
      * @param subtype 
      * @param outcome 
      * @param limit Number results
      * @param paginationBookmark Bookmark used to paginate the results
      */
 filter(date: Array<string>, address?: Array<string>, agentIdentifier?: Array<string>, patientIdentifier?: Array<string>, entityIdentifier?: Array<string>, entityType?: Array<string>, entityRole?: Array<string>, sourceIdentifier?: Array<string>, type?: Array<string>, subtype?: Array<string>, outcome?: Array<string>, limit?: number, paginationBookmark?: string): Promise<PaginatedListSyslog> {
    let _body = null
    
    const _url = this.host + `/syslogs/filter` + "?ts=" + new Date().getTime() 
          + (date ? date.map(v => "&date=" + encodeURIComponent(String(v))).join("") : "")
          + (address ? address.map(v => "&address=" + encodeURIComponent(String(v))).join("") : "")
          + (agentIdentifier ? agentIdentifier.map(v => "&agent.identifier=" + encodeURIComponent(String(v))).join("") : "")
          + (patientIdentifier ? patientIdentifier.map(v => "&patient.identifier=" + encodeURIComponent(String(v))).join("") : "")
          + (entityIdentifier ? entityIdentifier.map(v => "&entity.identifier=" + encodeURIComponent(String(v))).join("") : "")
          + (entityType ? entityType.map(v => "&entity-type=" + encodeURIComponent(String(v))).join("") : "")
          + (entityRole ? entityRole.map(v => "&entity-role=" + encodeURIComponent(String(v))).join("") : "")
          + (sourceIdentifier ? sourceIdentifier.map(v => "&source.identifier=" + encodeURIComponent(String(v))).join("") : "")
          + (type ? type.map(v => "&type=" + encodeURIComponent(String(v))).join("") : "")
          + (subtype ? subtype.map(v => "&subtype=" + encodeURIComponent(String(v))).join("") : "")
          + (outcome ? outcome.map(v => "&outcome=" + encodeURIComponent(String(v))).join("") : "")
          + (limit ? "&limit=" + encodeURIComponent(String(limit)) : "")
          + (paginationBookmark ? "&paginationBookmark=" + encodeURIComponent(String(paginationBookmark)) : "")
    let headers = this.headers
    return XHR.sendCommand("GET", _url, headers, _body, this.fetchImpl)
      .then(doc => 
          
              new PaginatedListSyslog(doc.body as JSON)
              
      )
      .catch(err => this.handleError(err))
}
}

